"use client";

import { useEffect, useRef } from "react";

/**
 * Locks body scroll when `isLocked` is true.
 * Saves and restores scroll position automatically.
 */
export function useScrollLock(isLocked: boolean) {
  const savedScrollY = useRef(0);

  useEffect(() => {
    if (!isLocked) return;

    savedScrollY.current = window.scrollY;

    document.body.style.position = "fixed";
    document.body.style.top = `-${savedScrollY.current}px`;
    document.body.style.width = "100%";
    document.body.style.overflowY = "scroll";

    return () => {
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      document.body.style.overflowY = "";
      window.scrollTo(0, savedScrollY.current);
    };
  }, [isLocked]);
}
